import { UseMutationOptions } from "@tanstack/react-query";
import { createConnectedAccountSession } from "services/api/connected-account-api.service";
import { QueryKey } from "common/enums/query-key";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { BackendError } from "common/types/errors/backendError";

export default function useCreateConnectedAccountSession(
  options?: Omit<UseMutationOptions<string, AxiosError<BackendError>, string, unknown>, 'mutationFn'>,
) {
  return useMutation({
    mutationFn: createConnectedAccountSession,
    mutationKey: [QueryKey.ConnectedAccount],
    onError: (e) => {
      console.log('Error while creating connected account session');
    },
    ...options,
  });
}